<template>
  <div />
</template>

<script>

/**
 * Vue: Technical details (technical-details)
 * -----------------------------------------------------------------------------
 * Multiple columns of product details.
 *
 * @param {String} sectionId - Section's Liquid ID.
 *
 */
import Splide from '@splidejs/splide'

import timings from '~/config/timings'
import { values as breakpoints } from '~/config/breakpoints'

export default {
  name: 'TechnicalDetails',

  props: {
    sectionId: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      selectors: {},
    }
  },

  mounted() {
    this.setSelectors()
    this.constructCarousel()
    this.setClickEvents()
  },

  methods: {

    /**
     * Sets event listeners and handles then.
     */
    setClickEvents() {
      if (this.selectors.previous) {
        this.selectors.previous.addEventListener('click', () => {
          if (this.carousel) {
            this.carousel.go('<')
          }
        })
      }

      if (this.selectors.next) {
        this.selectors.next.addEventListener('click', () => {
          if (this.carousel) {
            this.carousel.go('>')
          }
        })
      }
    },

    /**
     * Sets the element selectors.
     */
    setSelectors() {
      const container = document.querySelector(
        `#vue-element [js-technical-details="${this.sectionId}"]`,
      )

      this.selectors = {
        container,
        carousel: container.querySelector('[js-technical-details="carousel"]'),
        active: container.querySelector('[js-technical-details="active"]'),
        previous: container.querySelector('[js-technical-details="previous"]'),
        next: container.querySelector('[js-technical-details="next"]'),
      }
    },

    /**
     * Constructs the carousel instance.
     */
    constructCarousel() {
      this.carousel = new Splide(this.selectors.carousel, {
        arrows: false,
        gap: 'var(--spacing-m)',
        pagination: false,
        speed: timings.slow,
        mediaQuery: 'min',
        breakpoints: {
          [breakpoints.l]: {
            destroy: true,
          },
        },
      })

      this.carousel.mount()

      /**
       * Set Splide events.
       */
      this.carousel.on('active', ({ index }) => {
        if (this.selectors.active) {
          this.selectors.active.textContent = String(index + 1).padStart(2, 0)
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@splidejs/splide/css/core';
@import './technical-details';
</style>
